import baseApi from "./baseApi.js";
import axios from '@/models/API/axios'
import * as apiUrl from './apiUrl.js';

/**
 * 帳單api
 */
class billApi extends baseApi {
    constructor() {
        super();
        this.baseApi = new baseApi();
    }

    /**
     * 查詢帳單
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    getBill(callback = {}, params = {}, is_loading = true) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_BILL}`,
            params: params,
            is_loading: is_loading,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 新增帳單
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 新增參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    addBill(callback = {}, params = {}, is_loading = true) {
      const options = {
          method: this.request.method.post,
          url: `${apiUrl.API_POST_BILL}`,
          data: params,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 更新帳單
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 更新參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    updateBill(callback = {}, params = {}, is_loading = true) {
      const options = {
          method: this.request.method.put,
          url: `${apiUrl.API_PUT_BILL}/${params.id}`,
          data: params,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 刪除帳單
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} id 刪除參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    deleteBill(callback = {}, id = {}, is_loading = true) {
      const options = {
          method: this.request.method.delete,
          url: `${apiUrl.API_DELETE_BILL}/${id}`,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 查詢帳單(攤平)
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getBillFlatten(callback = {}, params = {}, is_loading = true) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_BILL_FLATTEN}`,
          params: params,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 銷帳單
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 銷帳參數
     */
    removeBill(callback = {}, params = {}) {
        const options = {
            method: this.request.method.post,
            url: `${apiUrl.API_POST_REMOVE_BILL}`,
            data: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 多筆銷帳單
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 銷帳參數
     */
    multiRemoveBill(callback = {}, params = {}, is_loading = true) {
        const options = {
            method: this.request.method.post,
            url: `${apiUrl.API_POST_MULTI_REMOVE_BILL}`,
            data: params,
            is_loading: is_loading,
            headers: { 'Content-Type': this.request.headers.contentType.appXWwwFormUrlEncoded }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 匯出未繳費帳單
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 匯出類型
     */
    exportBill(callback = {}, params = {}) {
        const options = {
            method: this.request.method.get,
            url: `${apiUrl.API_GET_EXPORT_BILL}`,
            params: params,
            is_loading: true,
            responseType: "blob",
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 批次銷帳
     * @param {Object.<string, string>} callback
     * @param {FromData} data 上傳檔案
     * @return {Object}
     */
    batchRemoveBill(callback = {}, data = new FormData()) {
        const options = {
            method: this.request.method.post,
            url: apiUrl.API_GET_BATCH_REMOVE_BILL,
            data: data,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.multipartFormData }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 查詢帳單報表
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getBillReport(callback = {}, params = {}) {
        const options = {
            method: this.request.method.post,
            url: `${apiUrl.API_GET_BILL_REPORT}`,
            data: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch((err) => {
            callback(err.response);
        });
    }

    /**
     * 產生帳單
     * @param {Object.<string, string>} callback
     * @return {Object}
     */
    outputBill(callback = {}) {
      const options = {
          method: this.request.method.post,
          url: apiUrl.API_POST_OUTPUT_BILL,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.multipartFormData }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 查詢帳單LOG
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     */
    getBillsLogs(callback = {}, params = {}) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_BILLS_LOGS}`,
          params: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 查詢2期催繳通知
     * @param {Object.<string, string>} callback
     */
    getUrgeBill(callback = {}) {
      const options = {
          method: this.request.method.post,
          url: `${apiUrl.API_GET_URGE_BILL}`,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 查詢設定自動扣款資料
     * @param {Object.<string, string>} callback
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    getSetAutoBill(callback = {}, is_loading = true) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_SET_AUTO_BILL}`,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 批次銷自動扣款帳單
     * @param {Object.<string, string>} callback
     * @param {FromData} data 上傳檔案
     * @return {Object}
     */
    batchRemoveAutoBill(callback = {}, data = new FormData()) {
      const options = {
          method: this.request.method.post,
          url: apiUrl.API_GET_BATCH_REMOVE_AUTO_BILL,
          data: data,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.multipartFormData }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
  }
}

export default billApi;



// WEBPACK FOOTER //
// ./src/models/API/billApi.js